/**
 * PipelineActivityLogButton — board-toolbar entry point for the per-pipeline
 * activity log (SE-5504).
 * @module features/player-kanban/components/organisms/PipelineActivityLogButton
 */

export { default } from "./PipelineActivityLogButtonContainer";
export type { PipelineActivityLogButtonContainerProps as PipelineActivityLogButtonProps } from "./PipelineActivityLogButtonContainer";
